export default {
      id: "huge-business-case-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-business-case",
      toString: function () {
        return this.url;
      }
    }